// Build 1 · Arrendamiento financiero (solo SOFOM). Espejo en pantalla de `backend/arrendamiento.py`:
// el IVA del bien, el valor residual y el capital a arrendar los fija SIEMPRE el backend.
export const TIPO_ARRENDAMIENTO = "Arrendamiento financiero";
export const GARANTIA_ARRENDAMIENTO = "Bien arrendado";
export const FUENTE_PAGO_ARRENDAMIENTO = "Ingresos del negocio / actividad empresarial";
export const IVA_BIEN_PCT = 16;
export const NOTA_IVA_RENTAS = "En arrendamiento financiero las rentas normalmente causan IVA; confirma el régimen con tu contador.";
export const NOTA_PROYECCION = "Proyección preliminar; la renta con valor residual se calcula al contratar.";

export const esArrendamiento = (producto) => String(producto?.tipo || "").trim() === TIPO_ARRENDAMIENTO;

const r2 = (n) => Math.round(Number(n) * 100) / 100;
const num = (v) => (v === "" || v == null || !Number.isFinite(Number(v)) ? null : Number(v));

// Montos derivados del bien (solo vista previa; el backend recalcula al guardar).
export function calcularBien(a) {
  const valor = num(a?.valor_bien_sin_iva);
  if (valor == null || valor <= 0) return {};
  const enganche = num(a?.enganche) ?? 0;
  const residual = num(a?.residual_pct);
  const iva = r2(valor * IVA_BIEN_PCT / 100);
  return {
    iva_bien: iva, valor_bien_con_iva: r2(valor + iva),
    capital_arrendar: r2(valor - enganche),
    valor_residual: residual == null ? null : r2(valor * residual / 100),
  };
}

export const descripcionGarantia = (a) => [a?.descripcion_bien, a?.marca, a?.modelo, a?.anio]
  .filter(Boolean).join(" ") + (a?.numero_serie ? `, serie ${a.numero_serie}` : "");

// Build 2 · Crédito de arrendamiento: tabla de RENTAS + fila técnica del residual (es_residual).
export const TITULO_RENTAS = "Rentas de arrendamiento";
export const LEYENDA_RENTAS_CUBIERTAS = "Rentas cubiertas · pendiente opción terminal";
export const esCreditoArrendamiento = (c) =>
  c?.tipo_amortizacion === "arrendamiento_residual" || c?.amort_input?.motor === "arrendamiento";
export const separarResidual = (tabla) => ({
  rentas: (tabla || []).filter((c) => !c.es_residual),
  residual: (tabla || []).find((c) => c.es_residual) || null,
});
// Derivada de la fila residual (no se persiste): rentas pagadas y residual sin pagar ni vencer.
export const rentasCubiertas = (tabla) => {
  const { rentas, residual } = separarResidual(tabla);
  return !!residual && rentas.length > 0 && rentas.every((c) => c.estatus === "Pagada")
    && !["Pagada", "Vencida"].includes(residual.estatus);
};
export const MODO_COMISION_ARR = { separado: "Por separado (cobro al cliente)", primera_cuota: "En la primera renta" };

// Build 3 · Opción terminal (Comprar, Prorrogar, Devolver) y correcciones del Build 2.
export const SISTEMA_ARRENDAMIENTO = "Arrendamiento con valor residual";
// «Registrar pago» bloqueado: rentas y diferidos cubiertos, residual pendiente → se paga desde la opción terminal.
export const MSG_PAGO_RENTAS_CUBIERTAS = "Las rentas están cubiertas. El residual y su mora se pagan desde Opción terminal en el detalle del crédito.";
export const pagoPorOpcionTerminal = (c) => {
  if (!esCreditoArrendamiento(c)) return false;
  const { rentas, residual } = separarResidual(c.tabla_amortizacion);
  const diferidos = Number(c.total_moratorios_diferidos_pendientes || 0) + Number(c.total_gastos_cobranza_diferidos_pendientes || 0);
  return !!residual && !residual.residual_cancelado && residual.estatus !== "Pagada" && rentas.length > 0
    && rentas.every((x) => x.estatus === "Pagada") && diferidos <= 0.005;
};
export const DOC_POLIZA_PRORROGA = "poliza_seguro_prorroga";
export const DOC_ACTA_ENTREGA = "acta_entrega_bien";
export const TIPOS_OT = { compra: "Compra", prorroga: "Prórroga", devolucion: "Devolución" };
const PPA = { Semanal: 52, Catorcenal: 26, Quincenal: 24, Mensual: 12, Bimestral: 6, Trimestral: 4, Semestral: 2, Anual: 1 };
// Estimación en pantalla (sin IVA) de la renta de la prórroga; la definitiva la fija el sistema al contratar.
export function rentaEstimada(capital, residual, plazo, tasa, periodicidad = "Mensual") {
  const n = Number(plazo), c = Number(capital), r = Number(residual || 0);
  if (!n || !c) return null;
  const i = Number(tasa || 0) / 100 / (PPA[periodicidad] || 12);
  if (i === 0) return r2((c - r) / n);
  const f = (1 + i) ** n;
  return r2(((c - r / f) * i * f) / (f - 1));
}
